<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs11> 
                 <v-progress-linear v-show="this.loaders.detail_loader" slot="progress" color="blue" indeterminate></v-progress-linear>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Edit Office</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <p class='err'>{{ error }}</p>

                                <v-form id="update_office" 
                                @submit.prevent="updateOffice" 
                                data-vv-scope="updateOffice" 
                                ref="office_form" v-model="valid"
                                 autocomplete="off"
                                 >
                                    <v-card-text>
                                        <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field name="Name" label="Name" id="name" v-model="office_object.name" v-validate="'required'" :error-messages="errors.collect('updateOffice.Name')">
                                                    <template v-slot:label >
                                                    Name <span style="color:red"> * </span>
                                                    </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-combobox :items="wings_list"
                                                     name="Wing" 
                                                     v-model="office_object.wing_id" 
                                                     id="id" label="Wing" 
                                                     item-text="name" 
                                                     item-value="id" 
                                                     clearable v-validate="'required'" 
                                                     :error-messages="errors.collect('updateOffice.Wing')">
                                                        <template v-slot:label >
                                                    Wing <span style="color:red"> * </span>
                                                    </template>
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5 >
                                                 <v-text-field name="Unit No" label="Unit No" id="unit_no" v-model="office_object.unit_no" v-validate="'required'" :error-messages="errors.collect('updateOffice.Unit No')">
                                                    <template v-slot:label >
                                                    Unit No <span style="color:red"> * </span>
                                                    </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-textarea name="Address" label="Address" 
                                                    id="address" v-model="office_object.address"
                                                     v-validate="'required'"
                                                      :error-messages="errors.collect('updateOffice.Address')" rows="3">
                                                        <template v-slot:label >
                                                    Address <span style="color:red"> * </span>
                                                    </template>
                                                    </v-textarea>
                                                </v-flex>
                                            </v-layout>
                                             <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field 
                                                    name="Email" 
                                                    label="Email" 
                                                    id="email" 
                                                    v-model="office_object.email" 
                                                    v-validate="'required'" 
                                                    :error-messages="errors.collect('updateOffice.Email')">
                                                    <template v-slot:label >
                                                    Email
                                                    <span style="color:red"> * </span>
                                                    </template>
                                                    </v-text-field>
                                                </v-flex>
                                               
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small :loading="loaders.submit_loader" :disabled="loaders.submit_loader" type="submit">Update</v-btn>
                                        <v-btn text small to="/offices">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
        <div>
    <v-snackbar
      v-model="snackbar"
    >
      {{ text }}
      <v-btn
        color="pink"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
        </div>
    </v-container>

</div>
</template>

<script>
export default {
    methods: {
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        updateOffice: function () {
            var wing_name = this.office_object.wing_id;
            if (this.office_object.wing_id.id == null) {
                this.office_object.wing_id = {};
                this.office_object.wing_id.id = null;
                this.office_object.wing_id.name = wing_name;
            }
            this.loaders.submit_loader = true;
            axios.post(`${process.env.VUE_APP_API_URL}/api/offices/` + this.$route.params.id + `/update`, this.office_object).then((response) => {
                if (response.data.status == 1) {
                    this.$router.push({
                        name: 'showOfficeDetails',
                        params: {
                            id: this.$route.params.id,
                            success_message:'Office Updated Successfully'
                        }
                    });
                    this.loading = false;
                    this.loaders.submit_loader = false;
                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {

            });
        },
        getOfficeDetails: function () {
            this.loaders.detail_loader = true;
            axios
                .get(
                    `${process.env.VUE_APP_API_URL}/api/offices/` +
                    this.$route.params.id + `/edit`
                )
                .then(response => {
                    if (response.data.status == 1) {
                        this.office_object = response.data.office;
                        this.office_object.wing_id = response.data.office.wing;
                        this.loaders.detail_loader = false;

                    }
                    if (response.data.status == 0) {
                        this.error = "Error Occured";
                        this.is_loading = false;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },
        getWingsList: function () {
            axios.get(`${process.env.VUE_APP_API_URL}/api/wings/list`).then((response) => {
                if (response.data.status == 1) {
                    this.wings_list = response.data.wings_list;

                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                    this.is_loading = false;
                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });
        },
    },
    data() {
        return {
            office_object: {
                name: '',
                address: '',
                wing_id: '',
                email:'',
            },
             snackbar: false,
            loaders: {
                detail_loader: false,
                submit_loader: false,
            },
            wings_list: [],
            error: '',
            valid: false,
           text:'',

        }
    },
    mounted() {
        this.getOfficeDetails();
        this.getWingsList();
    }
};
</script>

<style scoped>
.theme--light.v-card {
    background-color: #FFFFFF;
    color: rgba(0, 0, 0, 0.87);
    padding: 4% 4% 3% 3%;
}
</style>
